(function () {
    'use strict';

    angular.module('myApp').directive('headerAlt', headerAlt);

    function headerAlt() {
        var directiveObj = {};
        directiveObj.controller = HeaderAltController;
        directiveObj.controllerAs = 'vm';
        (directiveObj.templateUrl = 'js/scripts/directives/header-alt/header-alt.html'),
            (directiveObj.restrict = 'E');
        directiveObj.replace = true;
        return directiveObj;
    }

    function HeaderAltController($scope, $stateParams, authApi, apiService, toastr) {
        var vm = this;

        if ($stateParams.emailVerificationToken) {
            apiService
                .getUserDataFromToken($stateParams.emailVerificationToken)
                .then(function (response) {
                    if (response) {
                        vm.logoURL = response.facilityLogo;
                    }
                })
                .catch(function (error) {
                    if (error && error.statusCode == 403) {
                        toastr.error(error.message);
                    } else if (error) {
                        toastr.error(error.message);
                    }
                });
        }
    }
})();
